import { gql } from 'graphql-request';

/**
 * Real-time change signals for the current organization.
 *
 * The payload is deliberately just a signal — no business data. Each event maps
 * to a React Query key which is then invalidated, so the refetch goes through
 * the normal authenticated HTTP query with this user's own role and arguments.
 * This replaces the 3-second polling of pending incidents, pending budget
 * requests and the pending-invoice count.
 */
export const organizationEvents = gql`
  subscription OrganizationEvents($organizationId: String!) {
    organizationEvents(organizationId: $organizationId) {
      entity
      action
      entityId
      organizationId
    }
  }
`;

const OrganizationEventGraphQL = { subscriptions: { organizationEvents } };

export default OrganizationEventGraphQL;
